<template>
    <notification-tray-item-logic v-if="item.data.type !== 'plan'" :item="item" v-slot="{ read, configs, designer, markRead }">
        <a class="notify-item d-flex align-items-center justify-content-between" role="button"
           :class="{'bg-gray-100': !read}" @click.prevent="openInvoice(item)">
            <div class="d-flex align-items-center">
                <div class="me-3">
                    <div class="icon-circle" :class="[designer.background]">
                        <i class="fi d-flex" :class="[designer.color, designer.icon]"></i>
                    </div>
                </div>
                <div>
                    <div class="small text-gray-500"> {{ item.created_at | moment("from", "now") }}</div>
                    <span class="font-weight-bold text-dark">{{ item.data.text && item.data.text.length > 75 ? item.data.text.substring(0, 75) + '...' : item.data.text }}</span>
                    <div class="fw-bold text-capitalize" v-if="item.data.from && item.data.to" :class="[designer.color]">
                        <span>{{ item.data.from }}</span> -> <span>{{ item.data.to }}</span>
                    </div>
                    <div class="fw-bold text-capitalize" v-if="item.data.from && !item.data.to" :class="[designer.color]">
                        <span>{{ item.data.from }}</span>
                    </div>
                </div>
            </div>
            <i v-if="!read" class="fi fi-rr-circle-small text-danger m-l-auto"></i>
        </a>
    </notification-tray-item-logic>
</template>

<script>
import NotificationTrayItemLogic from "./NotificationTrayItemLogic.vue";
import ChildInvoicePanel from "../../ParentChildProfile/organisms/ChildInvoicePanel.vue";

export default {
    name: "InvoiceNotificationTrayItem",
    props: {
        item: Object | Array
    },
    components: {
        NotificationTrayItemLogic,
    },
    methods: {
        openInvoice() {
            this.$showPanel({
                component: ChildInvoicePanel,
                openOn: 'right',
                width: 576,
                cssClass: 'sidePanel',
                props: {
                    invoice: this.item.data.data,
                }
            })
        }
    }
}
</script>
